import { useState } from "react";
import { dragAndDrop } from "../../asset";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PageHeader from "../../components/PageHeader";
import { ticketsList } from "../../types/helpDeskType";
import DocumentUpload from "../../components/common/DocumetUpload";
import helpDeskApis from "../../api/helpDeskApis";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function CreateNewTickets() {
  const branchCode = useBranchCode()
  const [formData, setFormData] = useState<ticketsList>({
    ticketTitle: "",
    ticketDescription: "",
    attachedFileUrl: "",
    branchCode,
  });

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileUpload = (url: string) => {
    setFormData((prev) => ({
      ...prev,
      attachedFileUrl: url,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const res = await helpDeskApis.createTicket(formData);

      if (res?.status === 1) {
        setFormData({
          ticketTitle: "",
          ticketDescription: "",
          attachedFileUrl: "",
          branchCode: branchCode,
        });
      }
    } catch {}
  };

  return (
    <div className="flex flex-col gap-5">
      <PageHeader showBack />
      <form
        className="bg-white p-7 rounded-lg grid gap-8"
        onSubmit={handleSubmit}
      >
        {/* <CustomInput
          name=""
          type="date"
          label="Ticket date"
          value=""
          onChange={handleChange}
        /> */}
        <CustomInput
          name="ticketTitle"
          label="Ticket title"
          value={formData.ticketTitle}
          onChange={handleChange}
          placeholder="Enter the ticket title"
        />
        <CustomInput
          name="ticketDescription"
          placeholder="Enter the ticket description..."
          label="Ticket description"
          value={formData.ticketDescription}
          onChange={handleChange}
        />
        <DocumentUpload
          value={formData.attachedFileUrl}
          onUploadComplete={handleFileUpload}
          label="Attach files"
          text={true}
          placeholderImage={dragAndDrop}
          showButton={false}
          className="h-[170px]"
        />

        <div className="flex justify-end items-end mt-5">
          <CustomButton
            color="bg-primary-500"
            text="Create Ticket"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
}
